import React, { useState, useEffect, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

function normalizeBaseUrl(url) {
  if (!url) return "";
  return url.endsWith("/") ? url.slice(0, -1) : url;
}

function AuthGate({ backendUrl, children }) {
  const baseUrl = normalizeBaseUrl(backendUrl);

  const [status, setStatus] = useState("checking"); 
  const [qrData, setQrData] = useState(null);
  const pollRef = useRef(null);

  useEffect(() => {
    if (!baseUrl) return;

    // ✅ full RESET at startup
    setQrData(null);
    setStatus("checking");

    verifySession();

    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [baseUrl]);

  async function verifySession() {
    try {
      const res = await fetch(`${baseUrl}/api/auth/me`, {
        credentials: "include",
        cache: "no-store"
      });

      if (res.ok) {
        setStatus("authenticated");
        // document.cookie = "session_id=; Max-Age=0; path=/";
        return;
      }
    } catch (err) {
      console.error("Session check failed:", err);
    }

    // ✅ Only if NOT authenticated start the QR flow
    startQrFlow();
  }

  async function startQrFlow() {
    try {
      const res = await fetch(`${baseUrl}/api/auth/qr/start`, {
        method: "POST",
        credentials: "include",
        cache: "no-store"
      });

      if (!res.ok) throw new Error("QR start failed");

      const data = await res.json();

      setQrData(data);
      setStatus("waiting");

      startPolling(data.token);
    } catch (err) {
      console.error("QR flow error:", err);
      setStatus("error");
    }
  }

  function startPolling(token) {
    if (pollRef.current) clearInterval(pollRef.current);

    pollRef.current = setInterval(async () => {
      try {
        const res = await fetch(`${baseUrl}/api/auth/qr/status/${token}`, {
          credentials: "include",
          cache: "no-store"
        });

        if (!res.ok) return;

        const data = await res.json();

        if (data.status === "reload") {
          console.log("🔄 Cookie ready, stopping polling and reloading...");

          if (pollRef.current) {
            clearInterval(pollRef.current);
            pollRef.current = null;
          }

          setTimeout(() => {
            window.location.reload();
          }, 200); // small delay to ensure cookie write
        }

      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 2000);
  }

  if (status === "authenticated") {
    return <>{children}</>;
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Álbum de Fotos – Inicio de sesión</h1>

      {status === "checking" && <p style={styles.text}>Comprobando sesión...</p>}

      {status === "waiting" && qrData && (
        <>
          <p style={styles.text}>Escanea el código QR con tu móvil para autorizar a Temi</p>

          <QRCodeCanvas value={qrData.qrUrl} size={320} />
        </>
      )}

      {status === "error" && (
        <p style={styles.text}>Error de conexión con el backend</p>
      )}
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  title: { fontSize: "44px", marginBottom: "28px", fontWeight: 900, textAlign: "center" },
  text: { fontSize: "30px", textAlign: "center", maxWidth: "900px", lineHeight: 1.25 }
};

export default AuthGate;
